<template>
  <div class="dark:bg-dark-0 light:bg-light-0 flex flex-col gap-px">
    <div
      v-for="i in [0, 1, 2]"
      class="grid grid-cols-5 h-24 gap-px overflow-hidden"
    >
      <template v-if="games?.[i]">
        <div class="flex flex-col justify-center items-center relative dark:bg-dark-2 light:bg-light-2">
          <div class="absolute -top-6 -left-6 bg-primary p-6 rotate-45" />
          <div class="absolute top-1 left-2 text-white">
            {{ i }}
          </div>
          <div>{{ dayjs(games[i].start_time).format('MM-DD') }}</div>
          <div>{{ dayjs(games[i].start_time).format('HH:mm') }}</div>
        </div>
        <div class="col-span-3 self-stretch grid grid-rows-3 gap-px">
          <div class="pl-10 flex items-center gap-2 dark:bg-dark-2 light:bg-light-2">
            <ImgIcon :src="getIcon(games[i].home_team)" />
            {{ games[i].home_team.name_ko }}
          </div>
          <div class="pl-16 flex items-center gap-2 dark:bg-dark-2 light:bg-light-2">
            VS
          </div>
          <div class="pl-10 flex items-center gap-2 dark:bg-dark-2 light:bg-light-2">
            <ImgIcon :src="getIcon(games[i].away_team)" />
            {{ games[i].away_team.name_ko }}
          </div>
        </div>
        <div class="self-stretch grid grid-rows-3 gap-px text-white">
          <div class="flex items-center justify-center bg-secondary ">
            {{ games[i].market?.participants[0].odds.at(0).v ?? '-' }}
          </div>
          <div class="flex items-center justify-center bg-secondary">
            {{ games[i].market?.participants[0].odds.length === 3 ? games[i].market?.participants[0].odds.at(1).v : '-' }}
          </div>
          <div class="flex items-center justify-center bg-secondary">
            {{ games[i].market?.participants[0].odds.at(-1).v ?? '-' }}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="flex flex-col justify-center items-center relative dark:bg-dark-2 light:bg-light-2">
          <div class="absolute -top-6 -left-6 bg-secondary p-6 rotate-45" />
          <div class="absolute top-1 left-2 text-white">
            {{ i }}
          </div>
          <div>IN-PLAY</div>
        </div>
        <div class="col-span-3 self-stretch grid grid-rows-1 gap-px">
          <div class="pl-10 flex items-center gap-2 dark:bg-dark-2 light:bg-light-2">
            진행중 경기가 없습니다
          </div>
        </div>
        <div class="self-stretch grid grid-rows-3 gap-px text-white">
          <div class="flex items-center justify-center bg-secondary">
            -
          </div>
          <div class="flex items-center justify-center bg-secondary">
            -
          </div>
          <div class="flex items-center justify-center bg-secondary">
            -
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script setup>
import ImgIcon from '@/components/Icons/ImgIcon.vue'
import { useTeam } from '@/composables/useTeam.js'
import { useLiveStore } from '@/stores/live.js'
import { dayjs } from '@/utils/index.js'
import { computed } from 'vue'

const { getIcon } = useTeam()

const liveStore = useLiveStore()
liveStore.fetchHot()

const games = computed(() => liveStore.hotGames.map(o => ({
  start_time: o.start_time,
  home_team: o.home_team,
  away_team: o.away_team,
  market: o.markets.find(market => ['1x2', 'HA', 'HA_OT'].includes(market.key))
})))

</script>
